import React, { FormEvent, useState } from "react";
import { SERVER_URL, FORGOT_PASSWORD_API_PATH } from "../../../../../global_vars";
import luxoraLogo from "../../../../../assets/luxora.png";


function ForgotPassword() {


    const [successStatusMsg, setSuccessStatusMsg] = useState("");
    const [failStatusMsg, setFailStatusMsg] = useState("");
    const [email, setEmail] = useState("");


    const sendResetPasswordRequest = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setSuccessStatusMsg("");
        setFailStatusMsg("");

        fetch(SERVER_URL+FORGOT_PASSWORD_API_PATH, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email
            }),
        }).then((resp) => {
            if(resp.status === 200) {
                setSuccessStatusMsg("Successfully sent password reset link to your email. You will receive the email if your email is registered with Luxora.");
            } else {
                setFailStatusMsg("Failed to send password reset link. Received: " + resp.status);
            }
        }).catch((error) => {
            console.log("Error occured while sending reset pass link: ", error);
            setFailStatusMsg("Failed to process request. Unknown error: " + error);
        });
    }


    return (
    <div>
        <div className="container h-100">
            <div className="row justify-content-sm-center h-100">
                <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-7 col-sm-9">
                    <div className="text-center my-5">
                        <img src={luxoraLogo} alt="Luxora Logo" className="logo" />
                    </div>

                    <div className="card shadow-lg">
                        <div className="card-body p-5">
                            <h1 className="fs-4 card-title fw-bold mb-4">Forgot Password</h1>
                            {
                                successStatusMsg !== "" ? <div className={"alert alert-success alert-dismissible fade show"} role="alert">
                                <div>{successStatusMsg}</div>
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setSuccessStatusMsg("")}></button>
                                </div> : <></>
                            }
                            {
                                failStatusMsg !== "" ? <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <div>{failStatusMsg}</div>
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setFailStatusMsg("")}></button>
                                </div> : <></>
                            }
                            <form method="POST" onSubmit={sendResetPasswordRequest} className="needs-validation">
                                <div className="mb-3">
                                    <label className="mb-2 text-muted">Email:</label>
                                    <input type="email" className="form-control" placeholder="someone@abc.com" value={email} onChange={(event) => setEmail(event.currentTarget.value)} name="email" required />
                                    <div className="invalid-feedback">
                                        Email cannot be empty
                                    </div>
                                </div>

                                <div className="d-flex align-items-center">
                                    <button type="submit" className="btn btn-primary ms-auto" >
                                        Reset Password
                                    </button>
                                </div>

                            </form>
                        </div>
                        <div className="card-footer py-3 border-0">
                            <div className="text-center">
                                Please <a href="/login" className="text-dark fw-bold">Login</a> here
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )

}



export default ForgotPassword;